import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class CaravanRuins1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.CARAVAN_RUINS1;
}

export default CaravanRuins1PoiTileEntity;
